import { css } from 'linaria';
import { styled } from 'linaria/react';

export const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid var(--control-minor);
  padding: var(--space-250) 0 var(--space-100);
`;

export const skeleton = css`
  background-color: var(--background-secondary);
`;

export const firstSkeleton = css`
  border-radius: 240px;
  height: 24px;
  width: 24px;
`;

export const secondSkeleton = css`
  width: 126px;
  height: 14px;
  border-radius: var(--rounding-m);
  margin-left: var(--space-100);
`;

export const threeSkeleton = css`
  width: 101px;
  height: 40px;
  margin-left: auto;
  border-radius: var(--rounding-l);
`;
